import { render } from "./TicketsTicketSummarySocios.vue?vue&type=template&id=5bc4986d"
import script from "./TicketsTicketSummarySocios.vue?vue&type=script&lang=ts"
export * from "./TicketsTicketSummarySocios.vue?vue&type=script&lang=ts"
script.render = render

export default script